export const themeColors = {
  midnight: '#080D18',
  midnightElevated: '#111827',
  blaze: '#FF6B21',
  blazeHover: '#E85A12',
  electricBlue: '#2F6BFF',
  electricBlueDark: '#2456D8',
  coolWhite: '#F6F8FC',
  surface: '#FFFFFF',
  surfaceMuted: '#EEF2F7',
  ink: '#131A2A',
  muted: '#667085',
  border: '#D7DEE9',
  courtMaple: '#E5B66F',
  courtMapleLight: '#EDC887',
  courtMapleDark: '#D6A052',
  courtLine: '#FFF7E8',
  success: '#16895F',
  warning: '#B56A00',
  danger: '#D92D20',
} as const
